import React, { useEffect, useRef } from 'react';
import { Button } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../../actions';
import PropTypes from 'prop-types';

const FontColor = props => {
  const dispatch = useDispatch();
  const enabledEditorId = useSelector(state => state.design.enabledEditorId);
  const currentFontColor = useSelector(state => state.design.fontColor);
  const fontColor = useSelector(state => state.design.colorPickerColor);
  const sidePanel = useSelector(state => state.design.sidePanel);
  const init = useRef(true);

  useEffect(() => {
    if (currentFontColor !== fontColor) {
      init.current = true;
      dispatch(designActions.changeColorPickerColor(currentFontColor));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFontColor]);

  useEffect(() => {
    if (init.current) {
      init.current = false;
      return;
    }
    if (sidePanel !== 'colorPicker' || fontColor === currentFontColor) return;

    const newStyle = {
      type: 'fontColor',
      all: props.entityId !== enabledEditorId,
      value: fontColor,
    };
    props.onChange(newStyle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fontColor]);

  const onToggle = e => {
    dispatch(designActions.setSidePanel('colorPicker'));
    e.preventDefault();
  };

  return <Button icon="tint" onMouseDown={onToggle} />;
};

FontColor.propTypes = {
  entityId: PropTypes.number,
  onChange: PropTypes.func,
  ids: PropTypes.any,
};

export default FontColor;
